import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

@Directive({
  selector: '[appPhone]'
})
export class PhoneDirective {

  constructor(private el: ElementRef, private control: NgControl) { }

  @HostListener('keyup', ['$event']) onKeyup(event: KeyboardEvent) {
    let value = this.el.nativeElement.value;

    if (value[0] === '+') {
      const y = value.substr(1, value.length).replace(/\D+/g, '');
      this.control.control.setValue(value[0] + y);
      this.control.control.setValidators([this.control.validator ? this.control.validator :
        Validators.nullValidator, Validators.maxLength(18), Validators.minLength(8)]);
        
      if (this.el.nativeElement.id === 'fax' && value.length === 1) {
        this.control.control.clearValidators();
        this.control.control.setValidators([Validators.maxLength(1), Validators.minLength(1)]);
        this.control.control.updateValueAndValidity();
      }
    }
    else {
      const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      // regex above masks the phone number to two section of 3 and one section of 4 adding in necessary masking such as paren and hyphen.
      this.control.control.setValue(value);
      this.control.control.setValidators([this.control.validator ? this.control.validator :
        Validators.nullValidator, Validators.maxLength(14), Validators.minLength(14)]);
    }
  }
}
